import React from 'react';
import { Paper, Typography, Button, IconButton, Tooltip, Divider } from '@mui/material';
import styles from './fileBrowserInfoCard.module.css';
import { MdContentCopy, MdFolder, MdInfo, MdPrint, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import SpecialCard from 'components/common/SpecialCard/SpecialCard';
import { useTranslation } from 'react-i18next';
export const FileBrowserInfoCard = ({ fileBrowserUrl, username, password }) => {
  const handleCopy = (text) => {
    navigator?.clipboard?.writeText(text);
  };

  const [visible, setVisible] = React.useState(false);
  const { t } = useTranslation();

  return (
    <SpecialCard title={t('printing.infoCard.title')} sx={styles.infoCard}>
      {/* <div className={styles.cardTitle}>
        <MdInfo color='primary' />
        <Typography variant='h5'>Nyomtatási folyamat információk</Typography>
      </div> */}
      <div className={styles.print_options_wrapper}>
        <div className={styles.section}>
          <Typography variant='h6' gutterBottom>
            {t('printing.infoCard.file')}
          </Typography>
          <Typography variant='body1' paragraph>
            {t('printing.infoCard.first')}
          </Typography>
          <Typography variant='body1' paragraph>
            {t('printing.infoCard.secondp1')}
            <b>{t('printing.infoCard.secondp2')}</b>
            {t('printing.infoCard.secondp4')}
            <b>{t('printing.infoCard.secondp3')}</b>
          </Typography>
        </div>
        <Divider orientation='vertical' flexItem />
        <div className={styles.section}>
          <Typography variant='h6' gutterBottom>
            {t('printing.infoCard.get')}
          </Typography>
          <div className={styles.credentialsContainer}>
            <div className={styles.credentialRow}>
              <Typography variant='body1'>
                <strong>{t('printing.infoCard.url')}:</strong>
              </Typography>
              <Typography variant='body1'>{fileBrowserUrl}</Typography>
              <Tooltip title='Másolás'>
                <IconButton className={styles.copyButton} onClick={() => handleCopy(fileBrowserUrl)} size='small'>
                  <MdContentCopy />
                </IconButton>
              </Tooltip>
            </div>
            <div className={styles.credentialRow}>
              <Typography variant='body1'>
                <strong>{t('printing.infoCard.username')}</strong>
              </Typography>

              <Typography variant='body1'>{username}</Typography>
              <Tooltip title='Másolás'>
                <IconButton className={styles.copyButton} onClick={() => handleCopy(username)} size='small'>
                  <MdContentCopy />
                </IconButton>
              </Tooltip>
            </div>
            <div className={styles.credentialRow}>
              <Typography variant='body1'>
                <strong>{t('printing.infoCard.password')}</strong>
              </Typography>

              <Typography variant='body1'>{visible ? password : '***********'}</Typography>
              {visible ? (
                <IconButton onClick={() => setVisible(!visible)} size='small'>
                  <MdVisibilityOff size={20} />
                </IconButton>
              ) : (
                <IconButton onClick={() => setVisible(!visible)} size='small'>
                  <MdVisibility size={20} />
                </IconButton>
              )}

              <Tooltip title='Másolás'>
                <IconButton className={styles.copyButton} onClick={() => handleCopy(password)} size='small'>
                  <MdContentCopy size={18} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <a className={styles.button} href={fileBrowserUrl} target='_blank' rel='noopener noreferrer'>
        <MdFolder />
        {t('printing.infoCard.open')}
      </a>
    </SpecialCard>
  );
};
